<div class="header">
  <h4 class="header-text">
    {{ 'aiChatBotName' | translateIn }}
  </h4>

  <button
    class="close"
    type="button"
    puButton
    size="m"
    uiType="quaternary"
    [onlyIcon]="true"
    (click)="close()">
    <pu-icon iconName="close" size="16" />
  </button>
</div>

<div
  class="body messages"
  ptInfiniteScroll
  [disabled]="disableInfiniteScroll()"
  (scrolled)="messagesScrolled()"
>
  @for (message of messages(); track message.id) {
    <div class="message">
      <bot-chat-message
        [message]="message"
        [isFirst]="$first"
        [chatStarted]="chatStarted()"
      />
    </div>

    @if (message.request) {
      <div class="message">
        <user-chat-message
          [text]="message.request"
          [time]="message.createdAt"
        />
      </div>
    } @else if (!$last) {
      <div class="started-container">
        <div class="started">
          {{ 'chatBot.greeting.ended' | translateIn }} {{ message.id | date: 'dd.MM.yyyy HH:mm' }}
        </div>
      </div>
    }
  }

  @if (isLoading()) {
    <ng-container *puSpinner="true"/>
  }
</div>

<div class="actions">
  @if (feedbackMessageId()) {
    <form [formGroup]="feedbackForm" class="feedback-form" (ngSubmit)="leaveFeedback()">
      <div class="feedback-form-header">
        {{ 'feedbackForm.header' | translateIn }}
      </div>

      <div class="reason">
        @for (reason of dislikeReasons; track reason.value) {
          <pu-radio-option
            class="reason-control"
            formControlName="feedbackType"
            controlId="feedbackType"
            [option]="reason"
          />
        }
      </div>

      <pu-text-area
        class="feedback"
        formControlName="text"
        [placeholder]="'feedbackForm.textArea.placeholder' | translateIn"
        [rows]="4"
        [resizeDisabled]="true"
        [disabled]="messages()[0]?.internalStatus === internalMessageStatus.pending"
      />

      <div class="feedback-form-buttons">
        <button
          type="submit"
          puButton
          size="l"
          uiType="primary"
        >{{ 'chatBot.buttons.leaveFeedback' | translateIn }}</button>

        <button
          type="button"
          puButton
          size="l"
          uiType="secondary"
          (click)="closeFeedbackForm()"
        >{{ 'chatBot.buttons.cancel' | translateIn }}</button>
      </div>
    </form>
  } @else {
    <form [formGroup]="chatQuestionForm" class="question-form" (ngSubmit)="send()">
      <pu-simple-input
        class="question"
        formControlName="question"
        [placeholder]="'questionForm.input.placeholder' | translateIn"
      />

      <button
        type="submit"
        puButton
        size="l"
        uiType="primary"
        [disabled]="disableSendQuestion()"
      >{{ 'chatBot.buttons.send' | translateIn }}</button>
    </form>
  }
</div>
